"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var functions_exports = {};
__export(functions_exports, {
  defaultLayerAttribute: () => defaultLayerAttribute,
  findLayerAttribute: () => findLayerAttribute,
  layerAttributeGroups: () => layerAttributeGroups,
  layerAttributes: () => layerAttributes
});
module.exports = __toCommonJS(functions_exports);
var import_util = require("@cartographerio/util");
function layerAttributeGroups(layer) {
  return layer.attributes;
}
function layerAttributes(layer) {
  return layer.attributes.flatMap((group) => group.attributes);
}
function findLayerAttribute(layer, attributeId) {
  for (const group of layer.attributes) {
    for (const attr of group.attributes) {
      if (attr.attributeId === attributeId) {
        return attr;
      }
    }
  }
  return void 0;
}
function defaultLayerAttribute(layer) {
  const attributes = layerAttributes(layer);
  if (layer.defaultAttribute == null) {
    return attributes[0];
  } else {
    const selected = attributes.find((attr) => {
      switch (attr.type) {
        case "FeatureAttribute":
          return false;
        case "StringAttribute":
        case "NumberAttribute":
        case "BooleanAttribute":
        case "TimestampAttribute":
        case "SurveyAttribute":
        case "TeamAttribute":
          return layer.defaultAttribute === attr.propertyName;
        case "AttachmentAttribute":
          return layer.defaultAttribute === attr.folderPropertyName;
        default:
          return (0, import_util.checkExhausted)(attr);
      }
    });
    return selected ?? attributes[0];
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  defaultLayerAttribute,
  findLayerAttribute,
  layerAttributeGroups,
  layerAttributes
});
//# sourceMappingURL=functions.js.map
